import React, { useEffect, useState } from "react";
import CheckboxCustom from "../../../../features/CheckboxCustom";
import useFacility from "../../../../utils/hooks/useFacility";
import useNewsletterConfirmation from "../../NewsletterConfirmation/useNewsletterConfirmation";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import EAButton from "../../shared/Buttons/EAButton";
import { useTranslation } from "react-i18next";

interface IProps {
  email?: string;
  onAllowMailingChange?: (value: boolean) => void;
}
const CheckBoxNewsletterKRK: React.FC<IProps> = ({ email, onAllowMailingChange }) => {
  const [form, setForm] = useState({ mail: "", name: "", lastName: "", checkbox1: false, checkbox2: false });
  const facilityIds = useFacility();
  const { sendInvite } = useNewsletterConfirmation();
  const newsletterActive = useSelector((state: State) => state.config.configuration?.newsLetterActive);
  // const privatePolicy = useSelector((state: State) => state.config.configuration?.regulaminList[0].file);
  const labelText = `Wyrażam zgodę na przetwarzanie danych osobowych w celu przesyłania przez Park Wodny w Krakowie S.A. bieżących informacji o swoich usługach, ofertach handlowych - na udostępniony adres poczty elektronicznej Klienta.`;
  const [openText, setOpenText] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (form.checkbox1 === true && email) {
      setTimeout(() => {
        sendInvite(facilityIds, email);
      }, 2000);
    }
    //eslint-disable-next-line
  }, [email]);

  return (
    <React.Fragment>
      <div style={{ marginTop: "16px" }} className="flex-start-center">
        <h5>Dołącz do newslettera</h5>
      </div>

      {newsletterActive && (
        <>
          <CheckboxCustom
            value={form.checkbox1}
            setValue={(value) => {
              setForm({ ...form, checkbox1: value });
              if (onAllowMailingChange) {
                onAllowMailingChange(value);
              }
            }}
            label={labelText}
          />

          {openText ? (
            <EAButton
              title={t("gotowe_schowaj")}
              onClick={() => setOpenText(!openText)}
              variant="text"
              noMargins
              color="secondary"
            />
          ) : (
            <EAButton title={t("przeczytaj_calosc")} onClick={() => setOpenText(!openText)} variant="text" noMargins />
          )}

          {openText && (
            <p className="newsletter__description">
              Wyrażam dobrowolną zgodę na przetwarzanie moich danych osobowych przez Park Wodny w Krakowie S.A. z
              siedzibą w Krakowie, ul. Dobrego Pasterza 126, 31-416 Kraków, tel.: 12 61 63 190 e-mail:
              biuro@parkwodny.pl, jako Administratora Danych Osobowych (dalej: ADO), dane kontaktowe do IOD :
              inspektor@parkwodny.pl. 1. Dane osobowe będą przetwarzane na podstawie zgody wyłącznie przez czas trwania
              udzielonej zgody. 2. Dane osobowe mogą być udostępnione przez ADO: pracownikom/współpracownikom,
              kontrahentom - umocowanym do ich przetwarzania przy działaniach, dot. celu określonego w zgodzie,
              podmiotom świadczącym na rzecz ADO usługi np.: techniczne i organizacyjne, w szczególności dostawcom usług
              teleinformatycznych, nstytucjom działającym i uprawnionym z mocy prawa. 3. Posiada Pan/Pani prawo dostępu
              do treści swoich danych oraz prawo ich sprostowania, jeśli są nieprawidłowe. 4. Przysługuje Panu/Pani
              prawo do zapomnienia, ograniczenia przetwarzania, prawo wniesienia sprzeciwu wobec przetwarzania danych
              oraz prawo wycofania w każdym czasie zgody na przetwarzanie danych. 5. Cofnięcie zgody następuje poprzez
              formularz.albo drogą pocztową na adres ADO wskazany wyżej lub poprzez złożenie wniosku w formie papierowej
              w punkcie informacji (przy kasach do wejścia na halę basenową w Parku Wodnym w Krakowie S.A.). Wycofanie
              zgody spowoduje natychmiastowe zaprzestanie przetwarzania Pani/Pana danych osobowych przez ADO. Wycofanie
              zgody nie wpływa na zgodność z prawem przetwarzania, które miało miejsce do czasu cofnięcia. 6. ADO nie
              zamierza przekazywać Pana/Pani danych osobowych do odbiorców zlokalizowanych poza Europejskim Obszarem
              Gospodarczym. 7. Nie będzie Pan/Pani podlegać decyzjom podejmowanym w sposób zautomatyzowany (bez udziału
              człowieka), a Pana/Pani dane osobowe nie będą profilowane, chyba, że wyda Pan/ Pani zgodę w tym zakresie
              ADO w celu zbudowania adekwatnej oferty usług dla Pana/Pani, w tym pakietu promocji 8. Ma Pan/Pani prawo
              wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pan/Pani, że przetwarzanie danych
              osobowych przez ADO narusza przepisy obowiązującego prawa, w szczególności Rozporządzenia Parlamentu
              Europejskiego i Rady (UE) 2016/679 z dnia 27.04.2016 r. w sprawie ochrony osób fizycznych w związku z
              przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy
              95/46/WE (dalej jako: „RODO”). ADO zapewnia środki ochrony danych osobowych zgodnie z obowiązującymi
              przepisami, w szczególności zgodnie z RODO.
            </p>
          )}
        </>
      )}
    </React.Fragment>
  );
};

export default CheckBoxNewsletterKRK;
